import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Protected } from "@/components/Protected";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import HowItWorks from "@/pages/HowItWorks";
import CompleteProfile from "@/pages/CompleteProfile";
import Browse from "@/pages/Browse";
import CreatePlan from "@/pages/CreatePlan";
import MyPlans from "@/pages/MyPlans";
import AdminControl from "@/pages/AdminControl";
import PlanPreview from "@/pages/PlanPreview";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      {/* Public shareable plan preview — no auth, no geo lock (invite/marketing surface) */}
      <Route path="/plan/:id" element={<PlanPreview />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route
        path="/complete-profile"
        element={
          <Protected profileStep>
            <CompleteProfile />
          </Protected>
        }
      />
      <Route
        path="/circle"
        element={
          <Protected>
            <Browse />
          </Protected>
        }
      />
      <Route
        path="/create"
        element={
          <Protected>
            <CreatePlan />
          </Protected>
        }
      />
      <Route
        path="/my-plans"
        element={
          <Protected>
            <MyPlans />
          </Protected>
        }
      />
      <Route
        path="/admin-control"
        element={
          <Protected>
            <AdminControl />
          </Protected>
        }
      />
    </Routes>
  );
}

// Hoisted so the Toaster doesn't receive a freshly-created object on every render
const TOAST_OPTIONS = {
  style: {
    background: "#15151A",
    border: "1px solid rgba(212,175,55,0.35)",
    color: "#FFFFFF",
  },
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" toastOptions={TOAST_OPTIONS} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
